export default "__VITE_ASSET__B2Q0nGlG__"